var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card__no-video-wrapper mc-video-history-new__grid-video-item-wrapper"},[_c('div',{staticClass:"mc-trackvideo-card__no-video-content"},[_c('img',{attrs:{"width":"68","src":_vm.calculatedSrc}}),_c('p',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }